("use strict");
import { creditCardPayments, fixedDepositsConstants } from "../_constants";
import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, exhaustMap } from "rxjs/operators";
import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import {
  ajaxError,
  cardSettlementTypesComplete,
  cardSettlementTypesError,
  myCreditCardsListError,
  creditCardOtpConfirmationComplete,
  creditCardOtpConfirmationError,
  creditCardPayBillComplete,
  creditCardPayBillError,
  creditCardPayFromListComplete,
  creditCardPayFromListError,
  creditCardPayToBanksListComplete,
  creditCardPayToBanksListError,
  creditCardResendOTPComplete,
  creditCardResendOTPError,
  creditCardValidateAmountComplete,
  creditCardValidateAmountError,
  validateDfccOtherCreditCardComplete,
  validateDfccOtherCreditCardError,
  payloadEncryptionSuccess,
  payloadEncryptionFail,
} from "../_actions";
export const validateDfccOtherCreditCardEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.VALIDATE_CLIENT_OTHER_CARD_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/validateClientOtherCard",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            validateDfccOtherCreditCardComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(validateDfccOtherCreditCardError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const payFromListEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CREDIT_CARD_PAY_FROM_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/payFromList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardPayFromListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardPayFromListError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const validateAmountEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CREDIT_CARD_VALIDATE_AMOUNT_REQUEST),
    mergeMap(async (action) => {
      try {
        const finalPayload = { ...action.payload };
        delete finalPayload.restoreData;
        const payload = await from(
          payloadFormatter(finalPayload, "/api/creditCardPayments/validateAmount"),
        ).toPromise();
        return payloadEncryptionSuccess(payload, action.payload);
      } catch (error) {
        return payloadEncryptionFail(error);
      }
    }),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/validateAmount",
          action.encryptedPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardValidateAmountComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardValidateAmountError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const payBillEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CREDIT_CARD_PAY_BILL_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/payBill",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardPayBillComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardPayBillError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const payeeTypesListEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CARD_SETTLEMENT_TYPES_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/payeeTypesList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            cardSettlementTypesComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(cardSettlementTypesError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const payToBanksListEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CREDIT_CARD_PAY_TO_BANKS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/payToBanksList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardPayToBanksListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardPayToBanksListError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const optConfirmationEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CREDIT_CARD_OTP_CONFIRMATION_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/otpConfirmation",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardOtpConfirmationComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(creditCardOtpConfirmationError(error), ajaxError(error)),
          ),
        );
    }),
  );
export const creditCardResendEpic = (actions$) =>
  actions$.pipe(
    ofType(creditCardPayments.CREDIT_CARD_OTP_RESEND_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/creditCardPayments/otpResend",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            creditCardResendOTPComplete(ajaxResponse.response),
          ),
          catchError((error) => of(creditCardResendOTPError(error))),
        );
    }),
  );
